import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const variants = {
    toLeft: { initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 } },
    toRight: { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 } },
    toTop: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 } },
    toBottom: { initial: { opacity: 0, y: -50 }, animate: { opacity: 1, y: 0 } },
    zoomIn: { initial: { opacity: 0, scale: 0.8 }, animate: { opacity: 1, scale: 1 } },
    zoomOut: { initial: { opacity: 0, scale: 1.2 }, animate: { opacity: 1, scale: 1 } },
    fade: { initial: { opacity: 0 }, animate: { opacity: 1 } },
};

const MotionDiv = ({
                       children,
                       duration = 0.3,
                       delay = 0,
                       classes = "col-12",
                       variant = "fade",
}) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-100px" });
    const motionVariant = variants[variant] || variants.fade;

    return (
        <motion.div
            ref={ref}
            className={classes}
            initial={motionVariant.initial}
            animate={isInView ? motionVariant.animate : {}}
            transition={{ ease: "easeOut", duration, delay }}
        >
            {children}
        </motion.div>
    );
};

export default MotionDiv;